import { render } from "./ProductChange.vue?vue&type=template&id=8cbdaf76"
import script from "./ProductChange.vue?vue&type=script&lang=js"
export * from "./ProductChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__